import { allTrackers } from "app/services/track/track";

export const campaignWizardTracking = {
    onWizardOpen: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "view", "Setup started");
    },
    onCountryAdd: (countryCode: number): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Country added", {
            country: countryCode.toString(),
        });
    },
    onCountryRemove: (countryCode: number): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Country removed", {
            country: countryCode.toString(),
        });
    },
    onNextStep1: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Next/Step 1");
    },
    onImportCSVClick: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Import CSV");
    },
    onCSVError: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "view", "CSV Error");
    },
    onImportKeywordListClick: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Import keyword list");
    },
    onStartMonitoring: (keywordsCount: number): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Start monitoring/Step 2", {
            keywordsCount: keywordsCount.toString(),
        });
    },
    onCampaignNameDone: (): void => {
        allTrackers.dispatchTrackEvent("Campaign Setup", "click", "Campaign name/Step 3");
    },
};
